import { useQuery } from '@tanstack/react-query';

import { merchantsService, FetchMerchantsParams } from '@aslanpay/portal-common-lib';

export function useFetchMerchants(params?: FetchMerchantsParams) {
  return useQuery(['fetchMerchants', params], () => merchantsService.fetchMerchants(params), {
    keepPreviousData: true, // useful for pagination
  });
}

export interface Merchant {
  id: string;
  name?: string;
  description?: string;
  url?: string;
  logoUrl?: string;
  categories?: Categories[];
  aliases?: string[];
  isPopular?: boolean;
}

export interface Categories {
  id: string;
  name: string;
}

export default useFetchMerchants;
